import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputUrlaubsart<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: name */
  name?: string;
  /** Alias: anzeigenAls */
  anzeigenAls?: string;
  /** Alias: kurzarbeit */
  kurzarbeit?: boolean;
  /** Alias: anspruchsmindernd */
  anspruchsmindernd?: boolean;
  /** Alias: zeitausgleich */
  zeitausgleich?: boolean;
  /** Alias: color */
  color?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputUrlaubsart> = {
  code: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  anzeigenAls: {
    alias: 'anzeigenAls',
  },
  kurzarbeit: {
    alias: 'kurzarbeit',
  },
  anspruchsmindernd: {
    alias: 'anspruchsmindernd',
  },
  zeitausgleich: {
    alias: 'zeitausgleich',
  },
  color: {
    alias: 'color',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputUrlaubsartEntityDefinition: EntitiyDefinition<InputUrlaubsart> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputUrlaubsart',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
